<!-- 客户选择下拉框 -->
<template>
  <el-select
      clearable
      filterable
      :model-value="selected"
      value-key="id"
      label-in-value
      :placeholder="placeholder"
      class="ele-fluid"
      @update:modelValue="updateValue"
  >
    <el-option
        v-for="item in props.data"
        :key="item.id"
        :label="item.name"
        :value="item"
    />
  </el-select>
</template>

<script setup>
  import {computed} from 'vue';

  const props = defineProps({
    // 数据源由父组件传入，是因为页面需要先挂载字体文件后，再执行其他方法
    data: Array,
    /** 选中的数据 */
    modelValue: Object,
    /** 提示文本 */
    placeholder: {
      type: String,
      default: 'Select'
    }
  });

  const emit = defineEmits(['update:modelValue']);

  /** 选中的 */
  const selected = computed(() => getSelected());

  const getSelected = () => {
    if (props.modelValue.family) {
      return props.data.find((x) => x.family === props.modelValue.family);
    } else {
      return undefined;
    }
  };

  /** 更新选中数据 */
  const updateValue = (value) => {
    emit('update:modelValue', value);
  };
</script>
